import React, { useContext } from 'react';
import get from 'lodash.get';
import classNames from 'classnames';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { PersonContext } from 'lib/ContextTypes/person';

import { getBodyItemComponent } from 'components/Article/getBodyItemComponent';
import Picture from 'components/Picture';
import { SocialProfileList } from 'components/Social/ProfileList';

const PersonLead = () => {
  const person = useContext(PersonContext);

  const bio = get(person, 'bio', [])
    .map((item, i) => getBodyItemComponent(item, i, false));

  const imageURL = get(person, ['primaryImage', 'url', 'primary']);

  const socialMediaProfiles = get(person, 'socialMediaProfiles', {});

  return (
    <div className="person-lead">
      <div className={classNames('person-lead__container layout-grid-container', { 'person-lead__container--sans-bio': !Array.isArray(bio) && !bio.length })}>
        <div className="person-lead__item layout-grid-item grid-col-8-m">
          <div className="person-lead__heading">
            <h2 className="person-lead__name">
              {person.name}
            </h2>
            <SocialProfileList profiles={socialMediaProfiles} />
          </div>

          {Array.isArray(bio) && bio.length > 0 && (
            <div className="person-lead__bio dn db-m">
              {bio}
            </div>
          )}
        </div>

        <div className="person-lead__image layout-grid-item grid-col-4-m">
          {imageURL && (
            <Picture
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_120x120,
                m: AIMS_FLAVORS.FOCAL_180x180,
                l: AIMS_FLAVORS.FOCAL_300x300,
              }}
              url={imageURL}
            />
          )}
        </div>

        {Array.isArray(bio) && bio.length > 0 && (
          <div className="person-lead__bio db dn-m mt4 w-100">
            {bio}
          </div>
        )}
      </div>
    </div>
  );
};

PersonLead.propTypes = {};

export { PersonLead };
